import { tabAccessControl } from "../../../_helpers/access-control";

let CallScheduleTabs = [
  {
    text: "Schedule",
    path: `/call-schedule`,
    applicationFeatureCode: "CallSchedules",
  },
  {
    text: "Call Logs",
    path: `/call-schedule-call-logs`,
    applicationFeatureCode: "CallLogs",
  },
  {
    text: "Surveys",
    path: `/call-schedule-surveys`,
    applicationFeatureCode: "SurveyResponse",
  },
];

function GetIndexByTabName(tabName) {
  return tabAccessControl(CallScheduleTabs).findIndex((x) => x.text == tabName);
}

export { CallScheduleTabs, GetIndexByTabName };
